const advertise = {
    dfdh: '對方電話:',
    sjmc: '商家名稱',
    qsrsj: '請輸入商家名稱',
    sjbzj: '商家保證金',
    wcl: '30日完成率',
    zcd: '總成單（買/賣）',
    cd: '30日成單',
    c: '次',
    fz: '分鐘',
    pjfx: '平均放行',
    zcsj: '註冊時間：',
    fbjy: '首次訪問法幣交易:',
    yxbd: '郵箱綁定',
    sjbd: '手機綁定',
    cjsm: '初級實名認證',
    gjsm: '高級實名認證',
    buy: '購買',
    sell: '出售',
    market: '市場',
    djfs: '定價方式',
    ggid: '廣告ID',
    time: '時間',
    type: '類型',
    ptgg: '普通廣告',
    gdjg: '固定價格',
    fdjg: '浮動價格',
    yjfw: '溢價範圍',
    unitPrice: '單價',
    totalPrice: '總價',
    price: '單價',
    sysl: '剩餘數量',
    ywcsl: '已完成數量',
    cz: '操作',
    xj: '下架',
    sj: '上架',
    edit: '編輯',
    delete: '刪除',
    all: '全部',
    qdxjm: '確認要下架本條廣告嗎？',
    qdxj: '下架確定',
    qdsjm: '確認要上架本條廣告嗎？',
    qdsj: '上架確定',
    confirm: '確定',
    cancel: '取消',
    qdscm: '確認要刪除本條廣告嗎？',
    deleteAdvertise: '刪除廣告',

    tjgm: '統計購買',
    tjcs: '統計出售',
    coins: '幣種',
    day7: '7天',
    day15: '15天',
    day30: '30天',
    tj: '統計',
    mrsl: '買入數量',
    mcsl: '賣出數量',
    mrjj: '買入均價',
    mcjj: '賣出均價',
    zcje: '支出金额',
    srje: '收入金額',
    zsxf: '總手續費',
    cjdd: '成交訂單',
    zdxx: '賬單信息',
    tips: '提示：每種交易對，買賣統計每天只能分別導出100次',
    dcdd: '導出訂單',
    orderNo: '訂單號',
    jybz: '交易幣種',
    number: '數量',
    total: '總額',
    fee: '手續費',
    zd: '賬單',

    tjskfs: '添加收款方式',
    skfs: '收款方式',
    name: '姓名',
    payAccount: '賬戶',
    sk: '收款',
    cz: '操作',
    delete: '刪除',
    edit: '修改',
    qdsc: '確定刪除?',
    tip: '提示',
    deleted: '已取消刪除',
    xzskfstt: '新增收款方式',
    xgskfs: '修改收款方式',
    khmc: '開戶姓名',
    yhkh: '銀行卡號',
    khh: '開戶行',
    khhszd: '開戶行所在地',
    khhmc: '開戶行名稱',
    wxzh: '微信賬戶',
    zfbzf: '支付寶支付',
    ewmsc: '二維碼上傳',
    jymm: '交易密碼',
    srkhh: '請輸入開戶行',
    xzszd: '請選擇開戶行所在地',
    srkhmc: '請輸入開戶行名稱',
    srzh: '請輸入賬號',
    scskm: '請上傳收款碼',
    srjymm: '請輸入交易密碼',
    scwjgd: '上傳頭像圖片大小不能超過 2MB!',

    jnbzj1: '您作為{gradeName}， 已繳納保證金{margin} USDT， 當前剩餘廣告額度{amount} USDT',
    k: '可',
    add: '追加',
    or: '或者',
    reduce: '減少',
    margin: '保證金',
    sqsxf: '*平台會向商家收取廣告成交額的{fee}}%作為手續費',
    hqed: '立即成為認證商家獲得更高限額',
    want: '我想',
    bb: '幣幣',
    price: '價格',
    ckj: '*市場參考價{price} {fiatCurrency}/USDT 固定價格不會隨市場波動',
    jyjg: '交易價格',
    mdjg: '錨定價格',
    gxhl: '*綜合銀行及多家交易所實時匯率，每5分鐘更新一次',
    szyj: '設置溢價',
    zjjy: '*可輸入負數，即在錨定價格基礎上折價交易',
    yjsz: '*交易價格=錨定價格*（1+溢價設置）',
    jyxz: '交易限制',
    jysl: '交易數量',
    sygged: '*交易數量不可超過當前剩餘廣告額度',
    zxxe: '最小單筆限額',
    zdxe: '最大單筆限額',
    fkqx: '付款期限',
    xnfk: '*需在此時限內付款',
    fkfs: '付款方式',
    xzskfs: '*全部幣種最多可增加5種收款方式',
    yhjy: '不與未完成高級實名認證的用戶交易',
    jygg: '*僅完成初級實名認證的用戶不能進入交易廣告',
    cyjy: '請選擇未完成指定購買次數的用戶，不能參與交易',
    bmfx: '*完成過購買的用戶，已大大降低資金來源不明的風險',
    qxz: '請選擇',
    jybz: '交易備註',
    tyzs: '我已知曉並同意遵守',
    jygz: '《交易規則》',
    yzm: '驗證碼',
    save: '保存',
    fbgg: '發布廣告',
    jsbzjcg: '減少保證金成功',
    zjbzjcg: '追加保證金成功',
    xzfs: '請選擇收款方式或付款方式',
    bankTip1: '銀行卡不能超過三種收款方式',
    wxTip2: '微信不能超過三種收款方式',
    zfbTip3: '支付寶不能超過三種收款方式',
    syjg: '請輸入價格',
    syjysl: '請輸入交易數量',
    zxxe: '請輸入最小單筆限額',
    zdxe: '請輸入最大單筆限額',
    fkqx: '請輸入付款期限',
    tyjygz: '請同意交易規則',
    tpyzm: '請輸入圖片驗證碼',
    jydx: '交易對象',

    zjbzj: '追加保證金',
    jsbzj: '減少保證金',
    xzdgged: '現最大廣告額度',
    zjbzjse: '追加保證金數額',
    jsbzjse: '減少保證金數額',
    zjhbzjed: '追加後保證金額度',
    jshbzjed: '減少後保證金額度',
    balance: '餘額',
    sy: '剩餘',
    kzj: '可追加',
    kjs: '可減少',
    otcsjxy: 'OTC商家服務規則協議',
    xsgz: '新手教程',
    jygz: '交易規則',
    jnbzj: '為保證OTC合法合規，規範相關各方行為，因此要求商家繳納一定數額保證金；',
    zjjnbzj: '保證金分為基礎額度和追加額度兩部分組成，基礎額度為必需繳納部分，追加部分可選則繳納或不繳；',
    kxs: '繳納基礎額度可享受',
    fbgged: '發布CNYT則按匯率計算）的廣告額度；',
    ggedbl: '追加部分的保證金與廣告額度比例為',
    eg: '如追加100 USDT 則廣告額度在基礎額度上增加 100 x',
    ggzedjs: '廣告總額度的計算公式為：基礎廣告額度+追加廣告額度 x',
    ttsjzxed: '普通商家追加保證金最小額度為',
    zdedw: '最大額度為',
    mgsjzd: '每個商家最多可以發布三條購買廣告和三條出售廣告。',
    hljj: 'USDT兌CNYT的匯率取自BiKing平台相關交易對過去24小時的均價（每小時記錄一次，並去掉了最高價與最低價），作為當前的匯率值；並且當匯率出現波動時，原先發布的廣告額度保持不變。',
    jcbzj: '基礎保證金',
    xt: '選填',
    njhded: '您將獲得的廣告額度為：',
    mbye: '買幣餘額：',
    zhzcbz: '賬戶資產不足，您可以從資產賬戶劃轉',
    qhz: '去劃轉',
    qdjnbzj: '確定繳納基礎保證金',
    tjbzj: '添加保證金',
    sqsjcg: '申請商家成功',
    exchange:'匯率切换'
  }
  export {
    advertise
  }


// WEBPACK FOOTER //
// ./src/i18n/lang/advertise/tw.js